import { unByKey } from "ol/Observable";
import { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import {
  STYLE_MD_LINE_VARIANT_KEY,
  STYLE_MD_STANDARD_LINE_VARIANT,
} from "../constants";

function ExtraLayerTagsLayer() {
  const backgroundLayer = useSelector((state) => state.backgroundLayer);
  const extraLayerTags = useSelector((state) => state.extraLayerTags);
  const [layers, setLayers] = useState();
  const [retry, setRetry] = useState(0);

  // Since last maplibre-gl version (> 10.12) the loading of style has probably changed
  // so we have to check manually, to make sure the source data are added with a
  // good timing.
  useEffect(() => {
    if (!backgroundLayer) {
      return;
    }
    const mbMap = backgroundLayer.mbMap;
    const style = mbMap?.getStyle();
    const layerss = style?.layers;
    let key;
    const onRetry = () => {
      setRetry(retry + 1);
    };

    if (!layerss) {
      if (mbMap && !style) {
        mbMap.once("idle", onRetry);
      } else if (!backgroundLayer.mbMap && !backgroundLayer.loaded) {
        key = backgroundLayer.once("load", onRetry);
      }
    } else {
      setLayers(layerss);
    }

    return () => {
      mbMap?.off("idle", onRetry);
      unByKey(key);
      setLayers();
    };
  }, [backgroundLayer, retry]);

  useEffect(() => {
    if (!layers || !backgroundLayer.mbMap?.getStyle()) {
      return;
    }
    layers.forEach((layer) => {
      const value = layer.metadata?.[STYLE_MD_LINE_VARIANT_KEY];
      if (value && value !== STYLE_MD_STANDARD_LINE_VARIANT) {
        backgroundLayer.mbMap.setLayoutProperty(
          layer.id,
          "visibility",
          extraLayerTags.includes(value) ? "visible" : "none",
        );
      }
    });
  }, [layers, extraLayerTags, backgroundLayer?.mbMap]);

  return null;
}

export default memo(ExtraLayerTagsLayer);
